import { z } from "zod";

export const backofficeFindSiteConstraintsSummaryResponseSchema = z.object({
  hasDefinitiveDeactivation: z.boolean(),
  hasTemporaryDeactivation: z.boolean(),
  hasLinkDeactivation: z.boolean(),
  hasPlanning: z.boolean(),
  hasModulationLimitation: z.boolean(),
});

export type BackofficeFindSiteConstraintsSummaryResponse = z.infer<
  typeof backofficeFindSiteConstraintsSummaryResponseSchema
>;
